export default __webpack_public_path__ + "static/media/products_541.55853665.jpg";